<template>
    <div>
        <div v-for="(item,index) in tableData" :class="{'disabled-btn':!item.authStatus}" :key="index">
            <div class="data-item" @click="changeChild(item)" :class="[item.parentId==-1?'parent-node':'child-node',{pointer:!item.children||item.children.length==0},{active:currentId==item.teachingUnitId},{'disabled-color':!item.authStatus},{'disabled-btn':!item.authStatus}]">
                <div class="line"></div>
                <div style="display: flex;align-items: center;">
                    <div class="overflow" style="margin-left: 1rem;width: 6rem;">{{ analysisIndex(item,index)}}</div>
                    <div style="margin-left: 2.1rem;" v-if="item.parentId==-1" :class="[{'disabled-border':!item.authStatus},{'active-border':currentId==item.teachingUnitId}]" class="iconfont icon-jiantou_yemian_xiangshang"></div>
                    <div style="margin-left: 2.5rem;" v-else class="circle" :class="[{'active-border':currentId==item.teachingUnitId},{'disabled-border':!item.authStatus}]"></div>
                    <el-tooltip effect="dark" :content="item.authStatus?item.name:'暂无权限'" placement="top-start">
                        <div class="overflow" :style="`margin-left: ${item.parentId==-1?'2':'2.4'}rem;flex: 1;`"><span style="font-weight: 700;" v-if="item.mainType">{{ '('+(item.mainType=='仿真软件'?'软件':item.mainType)+')' }}</span>{{ item.name }}</div>
                    </el-tooltip>
                    <!-- <div  v-if="item.mainType=='视频'" style="margin-left: 1rem;min-width: 5rem;">{{ item.videoTime }}</div> -->
                    <el-tooltip effect="dark" v-if="item.studyStatus=='0'" :content="item.authStatus?'学习中':'暂无权限'" placement="top-start">
                        <i class="iconfont icon-xuexiditu-xuexizhong" style="font-weight: 700;color: #909399;font-size: 16px;"></i>
                    </el-tooltip>
                    <el-tooltip effect="dark" v-if="item.studyStatus=='1'" :content="item.authStatus?'已完成':'暂无权限'" placement="top-start">
                        <i class="iconfont icon-yiwancheng" style="font-weight: 700;color: #a4da89;font-size: 16px;"></i>
                    </el-tooltip>
                </div>
            </div>
            <chapter-tree :currentId="currentId" v-if="item.children&&item.children.length>0" :tableData="item.children" :lastIndex="sortIndex(index)"></chapter-tree>
        </div>
    </div>
</template>

<script>
import Utils from '@/assets/js/Utils';
    export default {
        name:'ChapterTree',
        props:['tableData','lastIndex','currentId'],
        data(){
            return{
                categoryIndex:'',
            }
        },
        methods:{
            changeChild(item){
                if(!item.authStatus)return;
                if(!item.children||item.children.length==0){
                    Utils.$emit('change_unit',item);
                }
            },
            sortIndex(index){
                if(this.lastIndex){
                    return [...this.lastIndex,index+1];
                }
                return [index+1];
            },
            analysisIndex(item,index){
                if(item.parentId==-1){
                    return '章节'+(index+1)
                }else{
                    return this.sortIndex(index).join('.');
                }
            }
        }
    }
</script>

<style lang="less" scoped>
.active{
    color: var(--blue) !important;
}
.parent-node{
    color: #334681;
    font-weight: 700;
    font-size: 16px;
}
.child-node{
    color: #334681;
    // color: #99A1BE;
}
.icon-jiantou_yemian_xiangshang{
    width: 2.4rem;
    height: 2.4rem;
    border: 1px solid #5d6995;
    border-radius: 50%;
    text-align: center;
    line-height: 2.4rem;
    font-size: 16px;
}
.line{
    height: 2rem;
    width: 2px;
    background-color: #EFEFF4;
    margin-left: 10.2rem;
}
.circle{
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: #f5f7fa;
    border: 1px solid #334681;
}
.pointer{
    cursor: pointer;
}
.active-border{
    border: 0.1rem solid var(--blue) !important;
}
.disabled-border{
    border: 0.1rem solid #C0C4CC !important;
}
</style>